export default "__VITE_ASSET__CVsIEc07__"